import { useState } from 'react';
import { CatalogBrowser } from './CatalogBrowser';
import { GarmentPreview } from './GarmentPreview';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import type { GarmentSummary } from '../lib/types';

/**
 * The catalogue, and nothing else.
 *
 * ⚠️ **Tapping a garment here opens it, it does not start a try-on.** This
 * screen used to be the entry point to the whole flow — any tap sent the
 * customer to the camera — which meant browsing and buying were the same
 * gesture, and a customer who only wanted a closer look ended up being asked
 * for a photo. Try-on is now its own section, entered deliberately from the nav
 * and gated on a photo.
 *
 * Nothing here touches quota, the camera, or the generation queue.
 */
export function GarmentsScreen() {
  const [open, setOpen] = useState<GarmentSummary | null>(null);

  return (
    <div className="flex flex-1 flex-col">
      <header className="px-4 pt-3">
        <h1 className="text-2xl font-bold text-primary">Garments</h1>
        <p className="mt-1 text-sm text-secondary">
          Browse the collection. Tap any garment for a closer look.
        </p>
      </header>

      <CatalogBrowser onSelect={setOpen} />

      <Modal
        open={open !== null}
        onClose={() => setOpen(null)}
        title={open?.name ?? 'Garment'}
        titleHidden
        footer={
          <Button variant="secondary" size="md" onClick={() => setOpen(null)}>
            Close
          </Button>
        }
      >
        {open && <GarmentPreview garment={open} />}
      </Modal>
    </div>
  );
}
